import { throwError } from 'rxjs';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';

export class BaseService {
  protected httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      lang: 'ar',
    }),
  };

  constructor() {}

  protected handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }
}
